import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../../../../enums/queryKeys'
import { fetchTrialBalanceReport } from '../../../../query-api'
import { ReportOptions } from '../../../../types/reportOptions'

interface UseFetchTrialBalanceReportProps {
  appliedFilters: ReportOptions
}

export const useFetchTrialBalanceReport = ({ appliedFilters }: UseFetchTrialBalanceReportProps) => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id || ''

  const { data, isLoading, isError } = useQuery(
    [QueryKeys.TrialBalance, organizationId, appliedFilters.hideZeroes, appliedFilters.period],
    () => fetchTrialBalanceReport(organizationId, appliedFilters),
    {
      enabled: !!organizationId,
    },
  )

  return {
    isError,
    isLoading,
    data: data || null,
  }
}
